module.exports = __webpack_public_path__ + "img/UTANTE.3e680229.png";